<template>
  <div class="box">
    <i-form
      ref="drug"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <Form-item label="药品名称" prop="drugname">
        <i-input
          v-model="formValidate.drugname"
          placeholder="请输入药品名称"
        ></i-input>
      </Form-item>
      <Form-item label="商品数量" prop="num">
        <i-input
          v-model="formValidate.num"
          placeholder="请输入商品数量"
        ></i-input>
      </Form-item>
      <Form-item label="生产厂家" prop="manufacturer">
        <i-input
          v-model="formValidate.manufacturer"
          placeholder="请输入生产厂家"
        ></i-input>
      </Form-item>
      <Form-item label="您的名字" prop="name">
        <i-input
          v-model="formValidate.name"
          placeholder="请输入您的名字"
        ></i-input>
      </Form-item>
      <Form-item label="邮箱" prop="email">
        <i-input
          v-model="formValidate.email"
          placeholder="请输入邮箱"
        ></i-input>
      </Form-item>
      <Form-item label="联系电话" prop="phone">
        <i-input
          v-model="formValidate.phone"
          placeholder="请输入联系电话"
        ></i-input>
      </Form-item>
      <Form-item label="用户留言" prop="message">
        <i-input
          v-model="formValidate.message"
          placeholder="请输入用户留言"
          type="textarea"
        ></i-input>
      </Form-item>
      <Form-item class="btn">
        <i-button type="primary" @click="handleSubmit()">提交</i-button>
        <i-button type="ghost" style="margin-left: 8px" @click="handleReset"
          >重置</i-button
        >
      </Form-item>
    </i-form>
  </div>
</template>

<script>
import { drugDemand } from "@api/public";
export default {
  name: "BuyDrugForm",
  data() {
    return {
      formValidate: {
        drugname: "",
        num: "",
        manufacturer: "",
        name: "",
        email: "",
        phone: "",
        message: ""
      },
      ruleValidate: {
        drugname: [
          { required: true, message: "药品名称不能为空", trigger: "blur" }
        ],
        num: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        manufacturer: [{ required: false, message: "", trigger: "blur" }],
        name: [
          { required: true, message: "您的名称不能为空", trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" }
        ],
        message: [{ required: false, message: "", trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.drug.validate(valid => {
        if (valid) {
          this.commitRequire();
        } else {
          this.$Message.error("信息填写不完整或错误，请继续填写");
        }
      });
    },
    handleReset() {
      this.$refs.drug.resetFields();
    },
    commitRequire() {
      drugDemand(this.formValidate).then(res => {
        if (res.status === 200) {
          this.$Modal.success({
            content: res.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.box
  padding 10px 30px 0 10px
  .btn
    transform translate(30%, -10px)
</style>
